<template>
  <label
    :for="id"
    :class="fieldClasses"
    :style="fieldStyle">

    <span
      v-if="label"
      ref="label"
      :class="labelClasses"
      :style="labelStyle">
      {{ label }}
      <span
        v-if="optional && !disabled"
        :class="optionalClass"
        :style="optionalStyle">
        <slot name="optional">{{ optionalMessage }}</slot>
      </span>

      <slot name="hint" />
    </span>

    <input
      :id="id"
      ref="input"
      :type="type"
      :class="inputClasses"
      :style="inputStyle"
      :value="inputValue"
      :placeholder="placeholderMessage"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
      v-bind="$attrs"
      v-on="listeners"
      :disabled="disabled">

    <div
      v-if="showClearButton"
      :class="clearButtonClasses"
      @click="onClear">
      <XIcon name="fa/solid/times-circle" />
    </div>

    <slot name="extra" />
  </label>
</template>

<script>
import FormControl from './mixins/FormControl'
import InputControl from './mixins/InputControl'

export default {
  mixins: [FormControl, InputControl],

  inheritAttrs: false,

  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: [String, Number]
    },
    placeholder: {
      type: String
    },
    clearButton: {
      type: Boolean,
      default: false
    },
    clearButtonClass: {
      type: [String, Array, Object],
      default: ''
    }
  },

  data () {
    return {
      inputValue: this.value,
      active: false,
      showClearButton: false
    }
  },

  watch: {
    value: {
      immediate: true,
      handler: function (newVal) {
        this.inputValue = newVal

        if (newVal) {
          this.active = true
        }

        if (this.clearButton) {
          this.showClearButton = !!newVal
        }
      }
    }
  },

  computed: {
    inputClasses () {
      return [...this.inputClass, 'appearance-none', {
        [this.activeClass.input]: this.active,
        [this.disabledClass.input]: this.disabled
      }]
    },

    clearButtonClasses () {
      let clearButtonClass = this.clearButtonClass
        ? this.clearButtonClass
        : this.$style['clear-button-default']

      return [this.$style['clear-button'], clearButtonClass]
    }
  },

  methods: {
    onClear () {
      this.inputValue = ''

      this.$emit('input', this.inputValue)
    }
  }
}
</script>

<style lang="scss" module>
.clear-button {
  top: 50%;
  transform: translateY(-10%);
}

.clear-button-icon {
  height: 1rem;
  vertical-align: -.1em;
}

/* DEFAULT STYLES - This will change */
.clear-button-default {
  position: absolute;
  right: 0;
  margin-right: .25rem;
  cursor: pointer;
  fill: currentColor;
}
</style>
